import { render, staticRenderFns } from "./BePlaceholderContent.vue?vue&type=template&id=d829fef6&scoped=true"
import script from "./BePlaceholderContent.vue?vue&type=script&lang=js"
export * from "./BePlaceholderContent.vue?vue&type=script&lang=js"
import style0 from "./BePlaceholderContent.vue?vue&type=style&index=0&id=d829fef6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d829fef6",
  null
  
)

export default component.exports